import { Page } from "../../../components/page-base";
import { BottomContainer, BtnsContainer, Container, FormRow, RegisterInputContainer } from "./styles";
import gpv from "../../../assets/images/logo-georanking.png";
import { InputLogin } from "../components/input";
import { useState } from "react";
import ActionButton from "../components/button";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { LoginService } from "../services";

export const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!token) {
      toast.error("Link de redefinição inválido. Solicite um novo.");
      return;
    }
    if (!newPassword || !confirmPassword) {
      toast.error("Preencha a nova senha e a confirmação.");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("Nova senha e confirmação não conferem.");
      return;
    }
    if (newPassword.length < 8) {
      toast.error("A nova senha deve ter pelo menos 8 caracteres.");
      return;
    }
    setLoading(true);
    try {
      const ok = await LoginService.resetPassword(
        token,
        newPassword,
        confirmPassword,
      );
      if (ok) {
        navigate("/login/admin");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page.Root>
      <Container>
        <FormRow>
          <div className="left-item">
            <img src={gpv} alt="" className="left-image" />
            <span className="left-title">Redefinir senha</span>
            <span className="left-subtitle">
              Crie uma nova senha para acessar sua conta
            </span>
          </div>
          <div className="right-item">
            <RegisterInputContainer>
              <InputLogin
                placeholder="Nova senha"
                type="password"
                setValue={setNewPassword}
                value={newPassword}
              />
              <InputLogin
                placeholder="Confirmar nova senha"
                type="password"
                setValue={setConfirmPassword}
                value={confirmPassword}
              />
            </RegisterInputContainer>
            <BtnsContainer>
              <a
                className="link"
                style={{ cursor: "pointer", fontSize: "14px", color: "#1264C7" }}
                onClick={() => navigate("/login/admin")}
              >
                Voltar ao login
              </a>
              <ActionButton label="Redefinir senha" onClick={handleSubmit} />
            </BtnsContainer>
          </div>
        </FormRow>
      </Container>

      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(255,255,255,0.65)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
          aria-busy
          aria-live="assertive"
        >
          <Page.Loader />
        </div>
      )}
      <BottomContainer>
        <a href="/terms-of-use" target="_blank" rel="noopener" style={{ marginRight: "1vw" }}>
          Termos de Uso
        </a>
        <a href="/privacy-policy" target="_blank" rel="noopener">
          Política de Privacidade
        </a>
      </BottomContainer>
    </Page.Root>
  );
};
